import { memo } from 'react';

import RegexIcon from '@/assets/regex-icon.svg?react';
import { merge } from '@/components';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type RegexLogoProps = VariantLogoProps;

const IRegexLogo = ({ className, ...rest }: RegexLogoProps) => {
  return (
    <FormatterValidatorLogo Icon={RegexIcon} className={merge('bg-purple-50 text-purple-700', className)} {...rest} />
  );
};

export const RegexLogo = memo(IRegexLogo) as typeof IRegexLogo;
